import React, {useContext} from 'react';
import {Grid, Container, Box, Button} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {ValidationErrorAlert, SSLReviewAlert} from './Alerts.jsx';
import {LoopContext} from 'components/forms/context';
import SSLDisplay from './SSLDisplay';

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        '& > *': {
            marginBottom: '1em',
        },
    },
    prompt: {
        color: theme.palette.primary.dark,
        fontWeight: 'bold',
    },
    addButton: {
        backgroundColor: theme.palette.primary.light2,
    },
}));

const SSLReview = ({
    state,
    showFormInfo,
    fieldErrorMappings,
    generalErrors,
    children,
    isEnd,
    allowEdit,
}) => {
    const classes = useStyles();
    const hasErrors =
        (fieldErrorMappings && Object.keys(fieldErrorMappings).length > 0) ||
        (generalErrors && generalErrors.length);

    let allErrors = [];
    if (fieldErrorMappings) {
        const fieldErrors = Object.keys(fieldErrorMappings)?.map(key => {
            return {message: `${key}: ${fieldErrorMappings[key]}`};
        });
        allErrors = [...generalErrors, ...fieldErrors];
    } else {
        allErrors = generalErrors || [];
    }
    const looper = useContext(LoopContext);

    const handleAddAnotherVessel = () => {
        looper.addNew();
        looper.goTo(0, window.location.pathname);
    };

    return (
        <Container>
            <Grid container justifyContent='space-around'>
                <Grid item sm={10} md={8}>
                    {children}
                </Grid>
            </Grid>

            {showFormInfo && isEnd && (
                <Box component='div' m={2} className={classes.prompt}>
                    {hasErrors
                        ? ValidationErrorAlert(allErrors)
                        : SSLReviewAlert()}
                </Box>
            )}
            <SSLDisplay showPicture={isEnd} inForm={true} state={state} />
            <div style={{minHeight: '20px'}}></div>
            {!isEnd || allowEdit ? (
                <Grid
                    container
                    direction='column'
                    alignItems='center'
                    style={{marginBottom: '1em'}}
                >
                    <Grid item>
                        <Button
                            variant='contained'
                            className={classes.addButton}
                            onClick={handleAddAnotherVessel}
                            data-cy='add-another-vessel'
                        >
                            + Add Another Vessel
                        </Button>
                    </Grid>
                </Grid>
            ) : null}
        </Container>
    );
};

export default SSLReview;
